import AuthLayout from "./layout";
import ResetPasswordLinkForm from "@components/auth/reset-password-link-form";

const ResetPasswordLinkPage = () => {
  return (
    <AuthLayout>
      <ResetPasswordLinkForm />
    </AuthLayout>
  );
};

export default ResetPasswordLinkPage;
